import { ApiKeyTutorialMessage } from '@constant/tutorial/ApiKeyTutorialMessage'
import { useResponsive } from '@hooks/useResponsive'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper'

const apiKeyTutorialList = [
  {
    message: ApiKeyTutorialMessage.step1,
    imagePath: '/apiKeyTutorial/step1.png',
  },
  {
    message: ApiKeyTutorialMessage.step2,
    imagePath: '/apiKeyTutorial/step2.png',
  },
  {
    message: ApiKeyTutorialMessage.step3,
    imagePath: '/apiKeyTutorial/step3.png',
  },
  {
    message: ApiKeyTutorialMessage.step4,
    imagePath: '/apiKeyTutorial/step4.png',
  },
  {
    message: ApiKeyTutorialMessage.step5,
    imagePath: '/apiKeyTutorial/step5.png',
  },
  {
    message: ApiKeyTutorialMessage.step6,
    imagePath: '/apiKeyTutorial/step6.png',
  },
  {
    message: ApiKeyTutorialMessage.step7,
    imagePath: '/apiKeyTutorial/step7.png',
  },
  {
    message: ApiKeyTutorialMessage.step8,
    imagePath: '/apiKeyTutorial/step8.png',
  },
  {
    message: ApiKeyTutorialMessage.step9,
    imagePath: '/apiKeyTutorial/step9.png',
  },
  {
    message: ApiKeyTutorialMessage.step10,
    imagePath: '/apiKeyTutorial/step10.png',
  },
  {
    message: ApiKeyTutorialMessage.step11,
    imagePath: '/apiKeyTutorial/step11.png',
  },
  {
    message: ApiKeyTutorialMessage.step12,
    imagePath: '/apiKeyTutorial/step12.png',
  },
  {
    message: ApiKeyTutorialMessage.step13,
    imagePath: '/apiKeyTutorial/step13.png',
  },
  {
    message: ApiKeyTutorialMessage.step14,
    imagePath: '/apiKeyTutorial/step14.png',
  },
  {
    message: ApiKeyTutorialMessage.step15,
    imagePath: '/apiKeyTutorial/step15.png',
  },
  {
    message: ApiKeyTutorialMessage.step16,
    imagePath: '/apiKeyTutorial/step16.png',
  },
]
const ApiKeyTutorialPage = props => {
  const { isMobile } = useResponsive()
  return (
    <div className='max-w-[850px] mx-auto pt-[14px] desktop:mt-2 mb-9 rounded-[4px]'>
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={50}
        pagination={{ clickable: true }}
        autoplay={false}
        slidesPerView={isMobile ? 1 : 2}
        slidesPerGroup={isMobile ? 1 : 2}
      >
        {apiKeyTutorialList.map(tutorial => (
          <SwiperSlide key={tutorial.imagePath} className=''>
            <div className='flex flex-col items-center justify-center gap-y-3  w-full h-full pb-8'>
              <img
                src={tutorial.imagePath}
                alt={tutorial.imagePath}
                className='object-cover max-h-[550px]'
              />
              <p className='text-sm text-center'>{tutorial.message}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
export default ApiKeyTutorialPage
